import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Logo = function Logo(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? "h-10 w-10 text-blue-600" : _ref$className;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    children: /*#__PURE__*/_jsx("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2",
      d: "M16 8v8m-4-5v5m-4-2v2m-2 4h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
    })
  });
};
export default Logo;